import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <path d="M36.932 37.955v30.9h-10.3v-30.9h10.3zm.6-9.5c.1 1.4-.5 2.8-1.6 3.8-1.2 1.1-2.7 1.6-4.2 1.5h-.1c-1.5.1-3-.5-4.1-1.5-1-1-1.6-2.4-1.6-3.8s.5-2.8 1.6-3.8 2.7-1.6 4.2-1.5c1.5-.1 3 .5 4.2 1.5 1.1 1 1.7 2.4 1.6 3.8zm36.4 22.8v17.7h-10.3v-16.5c.1-1.8-.3-3.6-1.3-5.1-.9-1.3-2.4-2-3.9-1.9-1.2 0-2.4.3-3.3 1.1-.9.7-1.6 1.6-2 2.7-.3.8-.4 1.7-.3 2.5v17.3h-10.3c0-8.3.1-15 .1-20.2v-10.7h10.3v4.5h-.1c.4-.6.8-1.2 1.3-1.7.5-.6 1.1-1.1 1.8-1.6.8-.6 1.7-1.1 2.7-1.4 1.2-.3 2.4-.5 3.6-.5 3.2-.1 6.4 1.2 8.6 3.5 2.3 2.8 3.4 6.5 3.1 10.3z" />
  </svg>
);
